

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { TaxCalculation } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveTaxCalculationPage extends Base {
  public taxCalculationsFields: Array<VFields<any>> = [];
  public taxCalculationsModel: TaxCalculation = {
    id: '',
    taxName: '',
    taxRate: '',
    taxPayableAccount: '',
  };

  public storeId: number = 0;
  public form: any = {};
  public taxCalculationId: string = '';

  public requestProgress: boolean = false;
  public userList: any[] = [];

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'TaxCalculation' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveTaxCalculations();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.taxCalculationId) {
      this.taxCalculationId = this.$route.params.taxCalculationId;
    }

    this.setTaxCalculationsFields();
    if (this.$route.params.storeId) {
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setTaxCalculationsFields(): void {
    this.taxCalculationsFields = [
      {
        key: 'taxName',
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Tax Name',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          required: true,
           rules:[
            v => this.required('Tax Name', v)
          ],
        },
      },
      {
        key: 'taxRate',
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Tax Rate As %',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          type: 'number', 
          required: true,
           rules:[
            v => this.required('Tax Rate As %', v)
          ],
        },
      },
      {
        key: 'taxPayableAccount',
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Tax Payable Account',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          required: true,
           rules:[
            v => this.required('Tax Payable Account', v)
          ],
        },
      },
    ];
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.taxCalculationsFields);
      const response = await storeService.getStore(this.storeId);
      const selectedTaxNumber = response.storeJson.taxCalculations.find(
        (m) => m.id === this.$route.params.taxCalculationId
      );

      if (this.taxCalculationId) {
        this.taxCalculationsModel.id = selectedTaxNumber.id;
        this.taxCalculationsModel.taxName = selectedTaxNumber.taxName;
        this.taxCalculationsModel.taxRate =
          selectedTaxNumber.taxRate;
        this.taxCalculationsModel.taxPayableAccount =
          selectedTaxNumber.taxPayableAccount;
      }
    } finally {
      this.formlyHideSkeleton(this.taxCalculationsFields);
    }
  }

  public validateTaxCalculation(): Vue & { validate: () => boolean } {
    return this.$refs.taxCalculationForm as Vue & { validate: () => boolean };
  }


  public async saveTaxCalculations(): Promise<void> {
    if (this.validateTaxCalculation().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (parseFloat(this.taxCalculationsModel.taxRate)>100) {
          this.showAlert(false, 'Tax rate should be less then or equal to 100.');
          return;
        }
        
        if (this.taxCalculationsModel.id === '') {
          await storeService.saveTaxCalculation(
            this.storeId,
            this.taxCalculationsModel
          );
          this.showAlert(true, 'Record Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tab: 'TaxCalculation'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updateTaxCalculation(
            this.storeId,
            this.taxCalculationsModel
          );
          this.showAlert(true, 'Record Updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                storeId: this.storeId.toString(),
                tab: 'TaxCalculation'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
